import { useQuery } from '@tanstack/react-query'
import { MINUTE_IN_MS } from '@/modules/shared/constants/time'
import { getQuarterExchangeRateStatus } from './getQuarterExchangeRateStatus'
import { Args, Props, Payload } from './types'

export function useQuarterExchangeRateStatusQuery(props: Props & Args) {
  return useQuery<Payload>({
    queryKey: [
      'quarter-exchange-rate-status',
      props.companyId,
      props.month,
      props.year,
    ],
    queryFn: async () => {
      const { data } = await getQuarterExchangeRateStatus(props)
      return data
    },
    enabled:
      !!props.companyId &&
      props.month !== undefined &&
      props.month !== null &&
      props.year !== undefined &&
      props.year !== null,
    staleTime: MINUTE_IN_MS * 5, // cache for 5 minutes
  })
}
